/**
 * Mock API response data for development
 * Simulates race tracking API response when real API is not available
 */
export const mockApiResponse = {
  race: {
    title: "Artvin-İskenderun Sürat Rekoru Denemesi",
    startTime: Math.floor(Date.now() / 1000) - 186400, // ~2 days ago
    totalDistance_NM: 1570,
    duration_sec: 186400 // ~2 days in seconds
  },
  tracks: [
    {
      id: 4170,
      lon: 36.425415,
      lat: 42.2153511,
      sog_kn: 7.55939531,
      cog_deg: 296,
      time: Math.floor(Date.now() / 1000) - 600, // 10 minutes ago
      distance_m: 450144.938,
      asog_kn: 5.94603014,
      completed: 0.154814541
    }
  ]
};

/**
 * Generate simulated position updates
 * Creates small variations in position, speed, and course
 * @returns {Object} Updated mock API response
 */
export const generateUpdatedPosition = (lastResponse) => {
  // Clone the last response
  const response = JSON.parse(JSON.stringify(lastResponse));
  
  // Update timestamps
  response.tracks[0].time = Math.floor(Date.now() / 1000);
  response.duration_sec += 30; // 30 seconds more elapsed
  
  // Small variation in speed (±0.3 knots)
  response.tracks[0].sog_kn += (Math.random() * 0.6 - 0.3);
  response.tracks[0].sog_kn = Math.max(2, Math.min(12, response.tracks[0].sog_kn));
  
  // Small variation in course (±2 degrees)
  response.tracks[0].cog_deg += Math.floor(Math.random() * 4 - 2);
  response.tracks[0].cog_deg = (response.tracks[0].cog_deg + 360) % 360;
  
  // Move position slightly based on speed and course
  const speedInDegrees = response.tracks[0].sog_kn * 0.0003; // Rough conversion for small movements
  const courseRad = response.tracks[0].cog_deg * Math.PI / 180;
  
  // Simple movement calculation (not accurate for long distances)
  response.tracks[0].lon += speedInDegrees * Math.sin(courseRad);
  response.tracks[0].lat += speedInDegrees * Math.cos(courseRad);
  
  // Increase distance and completion percentage
  const distanceIncreaseMeters = response.tracks[0].sog_kn * 0.5144 * 30; // knots to m/s * 30 seconds
  response.tracks[0].distance_m += distanceIncreaseMeters;
  
  // Update completion percentage
  response.tracks[0].completed = response.tracks[0].distance_m / (1570 * 1852); // total distance in meters
  
  // Update average speed
  response.tracks[0].asog_kn = (response.tracks[0].distance_m / 1852) / (response.duration_sec / 3600);
  
  return response;
};

const mockData = {
  mockApiResponse,
  generateUpdatedPosition
};

export default mockData;
